import * as Yup from "yup";

import {
    phoneRegex,
    zipRegex,
    stateRegEx,
    dateCantBeInFuture
} from "./validationFunctions";



export const patientInfoValidations = (section, formType, languageText) => {

    if (section.active) {
        return Yup.object().shape({


            PFName: section.fields.PFName.validations.required.value && Yup.string().required(
                () =>
                    languageText.ErrorChecking.ValidatorText.FirstName
            ),
            PLName: section.fields.PLName.validations.required.value && Yup.string().required(
                () =>
                    languageText.ErrorChecking.ValidatorText.LastName

            ),
            PPhone: formType.includes('Patient') && section.fields.PPhone.validations.required.value && Yup.string()
                .required(
                    () =>                        
                        languageText.ErrorChecking.ValidatorText.PhoneNumber
                )
                .matches(
                    phoneRegex,
                    languageText.ErrorChecking.ValidatorText.PhoneNumberInvalid
                ),
            Patient_Phone_Conform: formType.includes('Patient') && section.fields.PPhone.validations.required.value && Yup.string()
                .required(
                    () =>                        
                        languageText.ErrorChecking.ValidatorText.PhoneNumberConfirm

                )
                .oneOf([formType.includes('Patient') && Yup.ref('PPhone'), '555'], languageText.ErrorChecking.ValidatorText.PhoneNumberMatch),

            PEmail: formType.includes('Patient') && section.fields.PEmail.validations.required.value && Yup.string()
                .required(
                    () =>
                        languageText.ErrorChecking.ValidatorText.Email)
                .email(
                    languageText.ErrorChecking.ValidatorText.EmailInvalid

                )
                .max(
                    section.fields.PEmail.validations.maxLength.value,
                    section.fields.PEmail.validations.maxLength.message
                ),
            Patient_Email_Conform: formType.includes('Patient') && section.fields.PEmail.validations.required.value && Yup.string()
                .required(
                    () =>
                        languageText.ErrorChecking.ValidatorText.EmailConfirm
                )
                // .oneOf([Yup.ref(`PEmail`), null], 'Email addresses must match'),
                .test(
                    'email-match',
                    languageText.ErrorChecking.ValidatorText.EmailMatch,
                    function (value) {
                        const { PEmail } = this.parent; // Get the value of the PEmail field
                        if (!PEmail || !value) {
                            // If either field is empty, consider them a match
                            return true;
                        }
                        // Compare lowercase versions of the email addresses
                        return value.toLowerCase() === PEmail.toLowerCase();
                    }
                ),
            PAddress1: formType.includes('Patient') && section.fields.PAddress1.validations.required.value && Yup.string()
                .required(
                    () =>
                        languageText.ErrorChecking.ValidatorText.MissingAddress
                )
                .max(
                    section.fields.PAddress1.validations.maxLength.value,
                    section.fields.PAddress1.validations.maxLength.message
                ),
            PAddress2: Yup.string()

                .max(
                    section.fields.PAddress2.validations.maxLength.value,
                    section.fields.PAddress2.validations.maxLength.message
                ),
            PCity: formType.includes('Patient') && section.fields.PCity.validations.required.value && Yup.string()
                .required(
                    () =>                        
                        languageText.ErrorChecking.ValidatorText.CityMissing
                )
                .max(
                    section.fields.PCity.validations.maxLength.value,
                    section.fields.PCity.validations.maxLength.message
                ),
            PState: formType.includes('Patient') && section.fields.PState.validations.required.value && Yup.string()
                .required(
                    () =>
                        languageText.ErrorChecking.ValidatorText.StateMissing
                    
            )
                .matches(stateRegEx, languageText.ErrorChecking.ValidatorText.StateInvalid)
                .max(
                    section.fields.PState.validations.maxLength.value,
                    section.fields.PState.validations.maxLength.message
                ),
            PMName: Yup.string()
                .max(
                    section.fields.PMName.validations.maxLength.value,
                    section.fields.PMName.validations.maxLength.message
                ),

            PDOB1: Yup.string()
                .required(
                    () =>
                        true &&
                        languageText.ErrorChecking.ValidatorText.MissingDOB
                )
                .max(
                    dateCantBeInFuture,
                    'future'
                )

                .test(
                    "PDOB",
                    languageText.ErrorChecking.ValidatorText.MissingDOB,
                    function (date) {
                        var enteredDate = new Date(date);
                        return enteredDate.getFullYear() >= 1880;
                    }
                ).nullable()
                .test(
                    "PDOB",
                    languageText.ErrorChecking.ValidatorText.DateCantBeFuture,
                    function (date) {
                        var todaysDate = new Date();
                        var enteredDate = new Date(date);
                        return todaysDate > enteredDate;
                    }
                )
                .test(
                    "PDOB",
                    languageText.ErrorChecking.ValidatorText.RequiresAdult,
                    function (date) {
                        if (formType.includes('Patient')) {
                            var enteredDate = new Date(date);
                            var month = new Date().getMonth() + 1
                            var day = new Date().getDate()
                            var year = new Date().getFullYear() - 18
                            return new Date(`${month}/${day}/${year}`) > enteredDate;
                        }
                        else { return true }
                    }
                ),

            PZip: formType.includes('Patient') && section.fields.PZip.validations.required.value && Yup.string()
                .required(
                    () =>
                        languageText.ErrorChecking.ValidatorText.ZipMissing
                )
                .matches(
                    zipRegex,
                    languageText.ErrorChecking.ValidatorText.InvalidZip
                )
        });
    }
};



